// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext, useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import S from './style';
import LoadingIcon from '../../components/LoadingIcon';
import { getQueryParams, useQuery } from '../../lib/utility';
import ErrorPage from '../ErrorPage';
import { useReplySupportIsLoading, useDataSupportList, useGetSupportList, useSupportListError, useSupportListIsLoading, useUpdateReadSupport, useReplySupport, useReplySupportError, useUpdateReadSupportError, useReplySupportData, useUpdateReadSupportIsLoading, useUpdateReadSupportData, useCreateNewSupport, useCreateNewSupportData, useCreateNewSupportIsLoading, useCreateNewSupportError, useUpdateSupportStatus, useUpdateSupportStatusData, useUpdateSupportStatusIsLoading, useUpdateSupportStatusError } from './hooks';
import MemberContext from '../../contexts/MemberContext';

const SupportPage = (): JSX.Element => {
  const [isFirst, setIsFirst] = useState<boolean>(true);
  const { id, sent } = getQueryParams(useQuery());
  const member = useContext(MemberContext);

  const getSupportList = useGetSupportList();
  const supportList = useDataSupportList();
  const isLoadingList = useSupportListIsLoading();
  const errorsList = useSupportListError();

  const replySupport = useReplySupport();
  const replySupportData = useReplySupportData();
  const isLoadingReply = useReplySupportIsLoading();
  const errorsReply = useReplySupportError();

  const updateReadSupport = useUpdateReadSupport();
  const updateReadSupportData = useUpdateReadSupportData();
  const isLoadingUpdateRead = useUpdateReadSupportIsLoading();
  const errorsUpdateRead = useUpdateReadSupportError();

  const createNewSupport = useCreateNewSupport();
  const createNewSupportData = useCreateNewSupportData();
  const isLoadingCreateNew = useCreateNewSupportIsLoading();
  const errorsCreateNew = useCreateNewSupportError();

  const updateSupportStatus = useUpdateSupportStatus();
  const updateSupportStatusData = useUpdateSupportStatusData();
  const isLoadingUpdateStatus = useUpdateSupportStatusIsLoading();
  const errorsUpdateStatus = useUpdateSupportStatusError();

  useEffect(() => {
    if (!isLoadingReply || !isLoadingUpdateRead || !isLoadingCreateNew || !isLoadingUpdateStatus) {
      getSupportList();
    }
  }, [isLoadingReply, isLoadingUpdateRead, isLoadingCreateNew, isLoadingUpdateStatus])

  useEffect(() => {
    if (id) {
      updateReadSupport(id);
    }
  }, [id])
  useEffect(() => {
    if (!isLoadingList && isFirst) {
      setIsFirst(false);
    }
  }, [isLoadingList])

  if (errorsList) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <ErrorPage />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (isFirst) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (id) {
    return (
      <MainLayout>
        <S.Wrapper>
          {supportList.length !== 0 && <S.SidebarList list={supportList} currentId={id} />}
          <S.ChatForm
            data={supportList.filter((data) => data.id == id)[0].replies}
            supportType={supportList.filter((data) => data.id == id)[0].supportType}
            username={member.username}
            replySupport={replySupport}
            currentId={id}
            isReplying={isLoadingReply}
            problemTitle={supportList.filter((data) => data.id == id)[0].title}
            problemStatus={supportList.filter((data) => data.id == id)[0].supportStatus}
            updateSupportStatus={updateSupportStatus}
          />
        </S.Wrapper>
      </MainLayout>
    );
  }
  return (
    <MainLayout>
      <S.Wrapper>
        {supportList.length !== 0 && <S.SidebarList list={supportList} />}
        <S.NewSupportForm
          createNewSupport={createNewSupport}
          errorsCreateNew={errorsCreateNew}
          isLoadingCreateNew={isLoadingCreateNew} />
      </S.Wrapper>
    </MainLayout>
  );
}

export { SupportPage as default }

